<h2 class="heading-3 center mb-40 sm-mb-20">Booking summary</h2>
<button class="close-panel" (click)="closePanel.emit()">
  <i class="fa-light fa-close"></i>
</button>
<section class="steps">
  @for (step of vm.jumps; track step.to.step; let index = $index) {
    <app-summary-section [index]="index + 1" [step]="step" (resumeStep)="resumeStep(step)" />
  }
</section>

<app-button
  dataLabel="close-button"
  class="mt-auto"
  [buttonOptions]="{
    fill: true,
    variant: 'secondary',
  }"
  (onClick)="closePanel.emit()"
>
  Close
</app-button>
